export default __webpack_public_path__ + "static/media/CNPQ.c6867e6c.png";